export default __webpack_public_path__ + "static/media/news28.0858c4b1.jpg";